export enum FileType {
  Image = 'Image',
  SpoilerImage = 'SpoilerImage',
  Video = 'Video',
  SpoilerVideo = 'SpoilerVideo',
  VideoNote = 'VideoNote',
  Animation = 'Animation',
  SpoilerAnimation = 'SpoilerAnimation',
  Voice = 'Voice',
  Audio = 'Audio',
  Document = 'Document',
  MessagePreview = 'MessagePreview',
  MessagePreviewUrl = 'MessagePreviewUrl',
  TopMessagePreview = 'TopMessagePreview',
  TopMessagePreviewUrl = 'TopMessagePreviewUrl',
  Custom = 'Custom'
}

export class MessageAttachment {
  file!: string
  type!: FileType
}

export enum MediaFileStatus {
  loading,
  success,
  error,
}

export interface MessageMedia {
  attachments: Array<MessageAttachment>
}
